export const TOUR_STEPS = [
  {
    title: "Welcome to The Personal Trainers Club!",
    content: "This tour is a bit outdated. It may visually highlight incorrect areas. But feel free to proceed for a quick tour! This will guide you through the tools available in the app. All tools are currently in demo mode. Click 'Next' to continue.",
    openSideBar: false,
    target: ".sidebar"
  },
  {
    title: "Sidebar Navigation",
    content: "Use this sidebar to access various tools and features.",
    openSideBar: true,
    target: ".sidebar"
  },
  {
    title: "Standalone Tools",
    content: "The tools section contains various standalone utilities to help you manage your training sessions. All tools are demos.",
    openSideBar: true,
    target: ".sidebar-link-tools"
  },
  {
    title: "SweatText SMS Reminders (Demo)",
    content: "This tool allows you to send SMS reminders to your clients. Click Next to explore.",
    openSideBar: true,
    navTo: "/tools/reminders/info",
    target: ".sidebar-link-reminders"
  },
  {
    title: "FitTracker Dashboard (Demo)",
    content: "FitTracker helps you track your clients' fitness progress. Let's start with the dashboard.",
    openSideBar: true,
    navTo: "/clients/example/dashboard",
    target: ".sidebar-link-dashboard"
  },
  {
    title: "FitTracker Goals (Demo)",
    content: "You can also manage your clients' fitness goals here.",
    openSideBar: true,
    navTo: "/clients/example/profile",
    target: ".sidebar-link-profile"
  },
  {
    title: "Session Scheduling Tool (Demo)",
    content: "Use this tool to schedule sessions with your clients.",
    openSideBar: true,
    navTo: "/clients/example/schedulingavailability",
    target: ".sidebar-link-availability"
  },
  {
    title: "Generate More Sessions (Demo)",
    content: "You can generate additional sessions for your clients here.",
    openSideBar: true,
    navTo: "/clients/example/regenerate",
    target: ".sidebar-link-regenerate"
  },
  {
    title: "Guided Workout Tool (Demo)",
    content: "This tool provides a guided workout experience for your clients.",
    openSideBar: true,
    navTo: "/clients/example/executeworkoutsession",
    target: ".sidebar-link-executeWorkoutSession"
  },
  {
    title: "Workout Programming Tool (Demo)",
    content: "Plan and manage workout programs using this tool.",
    openSideBar: true,
    navTo: "/workoutlibrary",
    target: ".sidebar-link-workoutlibrary"
  },
  {
    title: "Exercise Details (Demo)",
    content: "View detailed information about specific exercises, such as the squat.",
    openSideBar: false,
    navTo: "/workouts/squat",
    target: ".sidebar-link-exerciseDetail"
  },
  {
    title: "Messaging Tool (Demo)",
    content: "Communicate with your clients using the messaging tool.",
    openSideBar: true,
    navTo: "/messages",
    target: ".sidebar-link-messages"
  },
  {
    title: "Payments Tool (Demo)",
    content: "Manage payments between you and your clients here.",
    openSideBar: true,
    navTo: "/clients/example/payments",
    target: ".sidebar-link-payments"
  },
  {
    title: "Basic Timer (Demo)",
    content: "Use this timer for tracking workout intervals.",
    openSideBar: true,
    navTo: "/tools/timer",
    target: ".sidebar-link-timer"
  },
  {
    title: "One Rep Max Estimator (Demo)",
    content: "Estimate your clients' one-rep max for various exercises.",
    openSideBar: true,
    navTo: "/tools/onerepmax",
    target: ".sidebar-link-onerepmax"
  },
  {
    title: "Protein Intake Calculator",
    content: "Estimate your clients' protein intake needs",
    openSideBar: true,
    navTo: "/tools/proteinintake",
    target: ".sidebar-link-proteinintake"
  },
  {
    title: "Client and Trainer Finder (Demo)",
    content: "This tool helps you find trainers or manage your clients. Let's explore the trainer profile.",
    openSideBar: true,
    navTo: "/profile",
    target: ".sidebar-link-trainerprofile"
  },
  {
    title: "Trainer Search (Demo)",
    content: "Search for trainers using this tool.",
    openSideBar: true,
    navTo: "/trainerssearch",
    target: ".sidebar-link-trainerdirectory"
  },
  {
    title: "My Clients (Demo)",
    content: "Manage your clients and view their profiles here.",
    openSideBar: true,
    navTo: "/clientlist",
    target: ".sidebar-link-clientlist"
  },
  {
    title: "End of Tour",
    content: "You're all set! Explore the tools and make the most of the app. Remember, all tools are currently in demo mode.",
    navTo: "/",
    target: null
  }
];
